import React, { useState } from "react";
import { CheckCircle, Circle } from "lucide-react";

const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const timeOptions = [
  "06:00",
  "06:30",
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
];

const RegisterStep2bis = ({ onNext }) => {
  const [schedule, setSchedule] = useState(() =>
    days.map((day) => ({
      day,
      active: true,
      open: "09:00",
      close: "18:00",
    }))
  );

  const handleToggle = (index) => {
    const updated = [...schedule];
    updated[index].active = !updated[index].active;
    setSchedule(updated);
  };

  const handleTimeChange = (index, field, value) => {
    const updated = [...schedule];
    updated[index][field] = value;
    setSchedule(updated);
  };

  const handleNext = () => {
    onNext(schedule);
  };

  return (
    <div className="min-h-screen bg-dry text-white flex flex-col items-center justify-start p-16 px-5">
      <div className="text-center mb-8 bg-drylight w-screen py-16 px-3">
        <h2 className="text-3xl md:text-4xl font-medium mb-2 text-text px-3">
          When are you open?
        </h2>
        <p className="text-textGray text-sm">
          Customers will see these hours when choosing a pickup time.
        </p>
      </div>
      <div className="w-full max-w-lg flex flex-col gap-0">
        {schedule.map((item, idx) => (
          <div
            key={item.day}
            className=" border-border rounded-lg p-4 flex flex-row md:flex-row md:items-center justify-between bg-dry"
          >
            <div className="flex items-center gap-3 mb-4 md:mb-0">
              <button
                onClick={() => handleToggle(idx)}
                className="focus:outline-none"
              >
                {item.active ? (
                  <CheckCircle size={16} className="text-redlight" />
                ) : (
                  <Circle size={16} className="text-border" />
                )}
              </button>
              <span className="text-sm font-medium">{item.day}</span>
            </div>

            {item.active && (
              <div className="flex items-center gap-2 ">
                <select
                  value={item.open}
                  onChange={(e) =>
                    handleTimeChange(idx, "open", e.target.value)
                  }
                  className="bg-dry text-text text-sm  border border-border px-2 rounded"
                >
                  {timeOptions.map((time) => (
                    <option key={time} value={time}>
                      {time}
                    </option>
                  ))}
                </select>

                <span className="text-sm text-text">to</span>

                <select
                  value={item.close}
                  onChange={(e) =>
                    handleTimeChange(idx, "close", e.target.value)
                  }
                  className="bg-dry text-text border border-border px-2 rounded text-sm"
                >
                  {timeOptions.map((time) => (
                    <option key={time} value={time}>
                      {time}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
        ))}
        <button
          onClick={handleNext}
          className="mt-10 py-3 px-8 bg-redlightlight text-redlight font-semibold rounded-md max-w-[100px] mx-auto"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default RegisterStep2bis;
